import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { AuthSessionService } from '../authentication/auth-session.service';
import { UniversalLoginService } from '../authentication/universal-login.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuardService {
  constructor(private authenticationService: AuthenticationService,
              private authSessionService: AuthSessionService,
              private universalLoginService: UniversalLoginService) {
  }

  async canActivate(): Promise<boolean | UrlTree> {
    let isLoggedIn = this.authenticationService.isLoggedIn();

    if (!isLoggedIn) {
      isLoggedIn = await this.authSessionService.ensureValidSession({
        allowBackgroundRefresh: false,
        isSilentRefresh: true,
      });
    }

    const authProviderId = this.authenticationService.getAuthProviderIdFromLocalStorage();

    if (!isLoggedIn || !authProviderId) {
      this.universalLoginService.redirectToLogin();
      return false;
    }
    return true;
  }
}
